import Types from "./Types";

const INITIAL_STATE = {
  video_requests: [],
  redo_exams: [],
  hw: [],
  isLoading: false,
  error: null,
  lastFetchedAt: null,
};

export default function adminNotifications(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_ADMIN_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        video_requests: payload?.video_requests || [],
        redo_exams: payload?.redo_exams || [],
        hw: payload?.hw || [],
        error: null,
        lastFetchedAt: Date.now(),
      };
    }
    case Types.GET_ADMIN_NOTIFICATIONS_FAIL: {
      return {
        ...state,
        error: payload || true,
      };
    }
    case Types.ADD_ADMIN_NOTIFICATIONS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }
    default: {
      return state;
    }
  }
}

